import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.admin.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-component-admin-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.admin.home/view.scss */
/* src/app/component.admin.home/view.scss: no such file or directory */`],
})
export class ComponentAdminHomeComponent implements OnInit {
    public machineCount: number | null = null;
    public totalQuantity: number | null = null;
    public totalWeight: number | null = null;
    public totalPlate: number | null = null;

    public gradeLog: any[] = [];
    public productChart: any[] = [];

    public eggprice: any = null;

    constructor(@Inject( Service)         public service: Service,@Inject( Title    )         private title: Title    ) { }

    async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, "/auth/login");
        if (!allowed) return;
        this.title.setTitle('에그텍스마트플랫폼 관리자 페이지');
        await this.load();
    }

    private async load() {
        const [statisticRes, eggPriceRes] = await Promise.all([
            wiz.call('statistic'),
            wiz.call('eggprice')
        ]);

        this.applyStatistic(statisticRes);
        this.applyEggPrice(eggPriceRes);

        await this.service.render();
    }

    private applyStatistic(response: any) {
        const { code, data } = response || {};
        if (code !== 200) return;

        this.machineCount = data.machines ?? 0;
        this.gradeLog = data.log ?? [];

        let quantity = 0;
        let weight = 0;
        let plate = 0;
        for (const item of this.gradeLog) {
            quantity += Number(item?.quantity ?? 0);
            weight += Number(item?.weight ?? 0);
            plate += Number(item?.plate ?? 0);
        }

        this.totalQuantity = quantity;
        this.totalWeight = weight;
        this.totalPlate = plate;

        this.productChart = [...this.gradeLog];
    }

    private applyEggPrice(chartres: any) {
        if (!chartres || chartres.code !== 200) return;

        const datasets = [
            {
                label: '왕란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#F37B48',
                borderColor: '#F37B48',
                tension: 0.01
            },
            {
                label: '특란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#D05A2A',
                borderColor: '#D05A2A',
                tension: 0.01
            },
            {
                label: '대란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#F4956A',
                borderColor: '#F4956A',
                tension: 0.01
            },
            {
                label: '중란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#FF9F7F',
                borderColor: '#FF9F7F',
                tension: 0.01
            }
        ];

        const labels: string[] = [];

        chartres.data.forEach((item: any) => {
            labels.push(item.date.substring(0, 10));
            datasets[0].data.push(item.egg1 ?? null);
            datasets[1].data.push(item.egg2 ?? null);
            datasets[2].data.push(item.egg3 ?? null);
            datasets[3].data.push(item.egg4 ?? null);
        });

        this.eggprice = {
            title: '계란시세 그래프 (원/30개)',
            link: '/admin/monitoring/eggprice',
            labels,
            datasets,
            options: {
                plugins: {
                    legend: {
                        position: 'right'
                    }
                }
            }
        };
    }
}

export default ComponentAdminHomeComponent;